// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"8bb91bcf","143":"d4fe2632","424":"49be167c","494":"873df7ed","533":"d4814aaf","651":"539bc5a1","690":"f34e8c81","852":"ed7afeb0","940":"6a2e1a63"}[chunkId] + ".chunk.js";
};